import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeHourglass = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 9H29",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 31H29",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 28V27.211C16.0001 27.0142 16.0581 26.8219 16.167 26.658L19.167 22.158C19.2583 22.021 19.382 21.9087 19.5272 21.8311C19.6723 21.7534 19.8344 21.7128 19.999 21.7128C20.1636 21.7128 20.3257 21.7534 20.4708 21.8311C20.616 21.9087 20.7397 22.021 20.831 22.158L23.831 26.658C23.9406 26.8223 23.999 27.0155 23.999 27.213V28H16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 31V27.211C13 26.4212 13.2338 25.6491 13.672 24.992L17 20L13.672 15.008C13.2338 14.3509 13 13.5788 13 12.789V9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 9V12.789C27 13.5788 26.7662 14.3509 26.328 15.008L23 20L26.328 24.992C26.7662 25.6491 27 26.4212 27 27.211V31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgTimeHourglass);
export default ForwardRef;
